import * as React from 'react';

interface Props {
    children: React.ReactNode | Function;
}

export class PaidBreakOptions extends React.PureComponent<Props> {
    // eslint-disable-next-line class-methods-use-this
    get options(): Record<string, any> {
        return [
            {
                text: 'None',
                value: null
            },
            {
                text: '10',
                value: 10
            },
            {
                text: '20',
                value: 20
            },
            {
                text: '30',
                value: 30
            },
            {
                text: '40',
                value: 40
            }
        ];
    }

    render(): React.ReactElement {
        const { children } = this.props;

        if (typeof children === 'function') {
            // @ts-ignore
            return children(this.options);
        }

        // @ts-ignore
        return React.cloneElement(children, { options: this.options });
    }
}

export default PaidBreakOptions;
